import { pickMiddleOffer } from './utils'

export function parseApiResponse(resultJson, prevResults) {
  const currentPlan = resultJson?.current_assessment?.cfos?.payoff_plans?.[0]
  const currentTime = currentPlan?.time_in_months
  const monthlyCurrent = Math.round(currentPlan?.tradeline_payoff?.[0]?.monthly_payment)
  const totalAmount = Math.round(currentPlan?.tradeline_payoff?.[0]?.amount)

  const offerAPL = pickMiddleOffer(resultJson?.default_offers?.apl_offers)
  const offerAHL = pickMiddleOffer(resultJson?.default_offers?.ahl_offers)
  const offerAR = pickMiddleOffer(resultJson?.default_offers?.ar_offers)

  const mapOffer = (offer, prev) => ({
    ...prev,
    resultMonthly: offer?.[0]?.monthly_payment || 0,
    resultTotal: offer?.[0]?.total_cost || 0,
    resultMonths: offer?.[0]?.terms || 0,
    active: offer != false,
  })

  return [
    mapOffer(offerAPL, prevResults[0]),
    mapOffer(offerAHL, prevResults[1]),
    mapOffer(offerAR, prevResults[2]),
    {
      ...prevResults[3],
      resultMonthly: monthlyCurrent || 0,
      resultTotal: totalAmount || 0,
      resultMonths: currentTime || 0,
    },
  ]
}
